import { createApi } from '@reduxjs/toolkit/query/react';
import { Response } from 'common/types';
import { ICertificateSignatureInput } from 'pages/private/MasterData/CertificateSignature/schema';
import { baseQuery } from 'redux/reducers/settings';

export interface ICourseCategoryResponse extends ICertificateSignatureInput {}

export interface ICourseCategoryInput {
  full_name: string;
  position: string;
  signature: any;
  id?: number;
}
export interface IPageQueryParams {
  page?: number | void;
  pageSize?: number | void;
}

export const certificateSignatureApi: { [key: string]: any } = createApi({
  reducerPath: 'certificateSignatureApi',
  baseQuery: baseQuery,
  tagTypes: ['CertifiacteSignature'],
  endpoints: (build) => ({
    listCertificateSignature: build.query<
      Response<ICourseCategoryResponse[]>,
      IPageQueryParams | null
    >({
      query: (paging) => `certificate/certificatesignature/list`,
      providesTags: (result, error, page) =>
        result
          ? [
              ...result.data.map(({ course_category_id }: any) => ({
                type: 'CertifiacteSignature' as const,
                id: course_category_id
              })),
              { type: 'CertifiacteSignature', id: 'PARTIAL-LIST' }
            ]
          : [{ type: 'CertifiacteSignature', id: 'PARTIAL-LIST' }]
    }),
    createCertificateSignature: build.mutation<ICourseCategoryResponse, ICourseCategoryInput>({
      query(body: any) {
        const form_data = new FormData();
        for (const key in body) {
          form_data.append(key, body[key] ?? '');
        }

        return {
          url: `certificate/certificatesignature/create`,
          method: 'POST',
          body: form_data // Use 'body', not 'form_data'
          // Do NOT set any content-type header here
        };
      },
      invalidatesTags: [{ type: 'CertifiacteSignature', id: 'PARTIAL-LIST' }]
    }),

    updateCertificateSignature: build.mutation<ICourseCategoryResponse, ICourseCategoryInput>({
      query(body: any) {
        const { id } = body;
        const form_data = new FormData();
        for (const key in body) {
          if (key !== 'id') {
            // Avoid appending id to FormData if backend expects it in URL
            form_data.append(key, body[key] ?? '');
          }
        }

        return {
          url: `certificate/certificatesignature/update/${id}/`,
          method: 'PATCH',
          body: form_data
          // Remove the headers entirely — let fetch handle content-type + boundary
        };
      },
      invalidatesTags: [{ type: 'CertifiacteSignature', id: 'PARTIAL-LIST' }]
    }),
    deleteCertificateSignature: build.mutation<ICourseCategoryResponse, string>({
      query(id) {
        return {
          url: `certificate/certificatesignature/delete/${id}/`,
          method: 'DELETE'
        };
      },
      invalidatesTags: [{ type: 'CertifiacteSignature', id: 'PARTIAL-LIST' }]
    })
  })
});

export const {
  useListCertificateSignatureQuery,
  useCreateCertificateSignatureMutation,
  useUpdateCertificateSignatureMutation,
  useDeleteCertificateSignatureMutation
} = certificateSignatureApi;
